import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Currency from "components/Currency";

const Container = styled.div.attrs({ className: "fee-numbers-card" })`
  && .left,
  && .right,
  && .title {
    font-weight: bold;
  }
  && .title {
    font-size: 14px;
    line-height: unset;
  }
  .numbers {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: 12px 0 0;
  }
  & .left {
    font-size: 20px;
  }
  .right {
    color: ${props => props.theme.colors.makoLighter};
  }
  .border-bot {
    background: ${props => props.theme.colors.solera};
    border-radius: 5px;
    height: 5px;
    margin-top: 12px;
  }
`;

const FeeNumbersCard = ({ title, left, right, ...rest }) => {
  return (
    <Container {...rest}>
      <h6 className="h6 title">{title}</h6>
      <div className="numbers mt">
        <span className="left h5">{left}</span>
        <span className="right">
          <Currency>{right}</Currency>
        </span>
      </div>
      <div className="border-bot" />
    </Container>
  );
};

FeeNumbersCard.propTypes = {
  title: PropTypes.string.isRequired,
  left: PropTypes.string.isRequired,
  right: PropTypes.string.isRequired
};

export default FeeNumbersCard;
